module.exports = __webpack_public_path__ + "img/matt_s.f00dcd67.png";